import { format } from 'date-fns'

const to_date = (unix: number) => format(new Date(unix * 1000), 'PP')

export { to_date }
